import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import { Validator } from 'vee-validate';
import elemEN from 'element-ui/lib/locale/lang/en'
import veeEN from 'vee-validate/dist/locale/en';
import { setLocaleHeader } from 'src/services/apiConfig'

const veeLangs = {
  en: veeEN,
}
let elementLangss = {
  en: elemEN,
}

Vue.use(VueI18n);

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([a-z0-9]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  });
  return messages
}

const defaultLang  = 'en';
const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || defaultLang,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || defaultLang,
  messages: loadLocaleMessages()
});


async function changeLanguage(lang) {
  let langModule = elementLangss[lang] || elementLangss.en;
  let veeValidateLang = veeLangs[lang] || veeLangs.en;
  Validator.localize(lang, veeValidateLang);
  locale.use(langModule.default);
  i18n.locale = lang;
  localStorage.setItem('locale', lang);
  setLocaleHeader(lang)
}

async function trySetLang() {
  await changeLanguage(defaultLang);
}

trySetLang();

export {
  changeLanguage
}

export default i18n;
